module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-26@2x-a6be7dc496d8b696687683cbdfd0476f.png";